import {
  ADD_MASTER_TASK,
  EDIT_MASTER_TASK,
  GET_MASTER_TASKS,
} from '../../../modules/constants';

export function getMasterTasks(value) {
  return {
    type: GET_MASTER_TASKS,
    payload: value,
  };
}

export function addMasterTask(payload) {
  return {
    type: ADD_MASTER_TASK,
    payload: { ...payload },
  };
}

export function editMasterTask(value) {
  return {
    type: EDIT_MASTER_TASK,
    payload: value,
  };
}
